import axios from 'axios'
import {getAdminToken} from '../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL
const adminApi = axios.create({withCredentials: true})
adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`
  return config
})

const base = `${API_URL}/admin/api-keys`

export interface ApiKey {
  id: string
  name: string
  key_prefix: string
  active: boolean
  allowed_ips: string[]
  trial_days: number | null
  accounts_created: number
  last_used_at: string | null
  last_used_ip: string
  notes: string
  created_at: string | null
}
export interface ApiKeyAccount {
  id: string
  name: string
  email: string
  phone: string
  trial_ends_at: string | null
  created_at: string | null
}

export function listApiKeys(): Promise<{data: {ok: boolean; endpoint: string; keys: ApiKey[]}}> {
  return adminApi.get(base)
}
export function createApiKey(data: {
  name: string
  notes?: string
  allowed_ips?: string[]
  trial_days?: number | null
}): Promise<{data: {ok: boolean; key: ApiKey; secret: string}}> {
  return adminApi.post(base, data)
}
export function updateApiKey(id: string, data: Partial<ApiKey>): Promise<{data: {ok: boolean; key: ApiKey}}> {
  return adminApi.put(`${base}/${id}`, data)
}
export function regenerateApiKey(id: string): Promise<{data: {ok: boolean; key: ApiKey; secret: string}}> {
  return adminApi.post(`${base}/${id}/regenerate`)
}
export function deleteApiKey(id: string): Promise<{data: {ok: boolean}}> {
  return adminApi.delete(`${base}/${id}`)
}
export function getApiKeyAccounts(id: string): Promise<{data: {ok: boolean; accounts: ApiKeyAccount[]}}> {
  return adminApi.get(`${base}/${id}/accounts`)
}
